import React from 'react';
import { FadeIn } from './FadeIn';
import { CTAButton } from './CTAButton';
export function FinalCTA() {
  return <section className="bg-periwinkle py-24 px-6 md:px-12 text-center" data-id="element-28">
      <div className="max-w-4xl mx-auto" data-id="element-29">
        <FadeIn data-id="element-30">
          <h2 className="text-4xl md:text-6xl text-cream mb-12" data-id="element-31">
            ¿Lista para volver a dormir?
          </h2>
          <CTAButton className="text-xl md:text-2xl py-6 px-10 mb-6 shadow-2xl" data-id="element-32">
            Quiero el Método SOS Sueño Infantil Ahora
          </CTAButton>
          <p className="text-cream/80 text-lg" data-id="element-33">
            Acceso inmediato a tu descanso después del pago.
          </p>
        </FadeIn>
      </div>
    </section>;
}